import { C, P0, R, S, abs, fillAt, max, rotPts, sq } from '../../geometry';

export const dino = {
  name: 'Dino',
  colors: ['#12A594', '#E3A008'],
  draw(m, t) {
    let h = (i) => 7 + 0.8 * S(t * 1.6 - i),
      tw = 3 * S(t * 1.4),
      pose = P0();
    if (m === 'happy') {
      h = (i) => 8 + 3 * abs(S(t * 7 + i * 0.6));
      tw = 10 * S(t * 9);
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: a ripple keeps running up the back plates while the tail swishes.
    if (m === 'thinking') {
      h = (i) => 4 + 8 * (0.5 + 0.5 * S(t * 5 - i * 1.3));
      tw = 9 * S(t * 2.5);
      pose.rot = 2 * S(t * 1.25);
    }
    if (m === 'talking') h = (i) => 6 + 3.5 * max(0, S(t * 10 - i));
    if (m === 'surprised') {
      h = () => 11;
      tw = -14;
      pose.ty = -2;
    }
    if (m === 'paused') {
      h = () => 3;
      tw = 12;
      pose.ty = 2;
      pose.sy = 0.94;
    }
    const cx = 47,
      cy = 60,
      hw = 25,
      hh = 22,
      p = 2.6;
    const at = (u) => [
      cx + hw * Math.sign(C(u)) * Math.pow(abs(C(u)), 2 / p),
      cy + hh * Math.sign(S(u)) * Math.pow(abs(S(u)), 2 / p),
    ];
    const plates = [-104, -72, -40, -8].map((d, i) => {
      const u = d * R,
        a = at(u - 0.2),
        b = at(u + 0.2),
        mid = at(u),
        nx = C(u) / hw,
        ny = S(u) / hh,
        nl = Math.hypot(nx, ny),
        H = h(i) + 2;
      const tip = [mid[0] + (nx / nl) * H, mid[1] + (ny / nl) * H];
      return { c: 'b', pts: [a, tip, b, a], sharp: true, n: 20 };
    });
    const tail = rotPts(
      [
        [64, 74],
        [80, 79],
        [91, 70],
      ],
      64,
      74,
      -tw
    );
    return {
      strokes: [
        { c: 'a', pts: tail },
        {
          c: 'a',
          pts: [
            [37, 78],
            [37, 89],
          ],
        },
        {
          c: 'a',
          pts: [
            [57, 78],
            [57, 89],
          ],
        },
        ...plates,
        { c: 'a', pts: sq(cx, cy, hw, hh, p), n: 30 },
      ],
      eyes: { x: 45, y: 58 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 3, 4, 5, 6, 7),
};
